import React, { useState, useEffect } from "react";
import { Box, Paper, Typography, TextField, Button, Alert, CardActionArea } from "@mui/material";
import { useTranslation } from "react-i18next";
import { backendUrl } from '../config';

// This page can be improved to fetch/save config via API
const API_URL = backendUrl;

export default function DatabaseConfigPage() {
  const { t } = useTranslation();
  const [dbUrl, setDbUrl] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(API_URL + "/api/config/database-url")
      .then(res => res.json())
      .then(data => {
        setDbUrl(typeof data === "string" ? data : data?.message || "");
        setLoading(false);
      });
  }, []);

  const handleSave = async () => {
    setMessage("");
    const res = await fetch(API_URL + "/api/config/database-url", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ new_url: dbUrl })
    });
    const data = await res.json();
    if (res.ok) {
      setMessage(t('settings.database.saveSuccess'));
    } else {
      setMessage(t('settings.database.saveError'));
    }
  };

  const handleClick = () => {
    // This function is not defined in the original code, 
    // so I'm assuming it's supposed to be defined here.
    // You may need to adjust this to fit your actual code.
  };

  return (
    <Box sx={{ p: 4, maxHeight: '70vh', overflow: 'auto' }}>
      <Paper elevation={2} sx={{ p: 3, maxWidth: 600, margin: "auto" }}>
        <Typography variant="h5" mb={2}>{t('settings.database.title')}</Typography>
        {loading ? (
          <Typography>{t('common.loading')}</Typography>
        ) : (
          <>
            <CardActionArea
              onClick={handleClick}
              onTouchStart={e => {
                e.stopPropagation();
                handleClick();
              }}
            >
              <TextField
                label="DATABASE_URL"
                fullWidth
                value={dbUrl}
                onChange={e => setDbUrl(e.target.value)}
                helperText={t('settings.database.helperText')}
                margin="normal"
              />
              <Button variant="contained" color="primary" onClick={handleSave} sx={{ mt: 2 }}>
                {t('common.save')}
              </Button>
            </CardActionArea>
          </>
        )}
        {message && <Alert severity="success" sx={{ mt: 2 }}>{message}</Alert>}
      </Paper>
    </Box>
  );
}
